import * as yup from "yup";

export const schema = yup
  .object({
    customTitle: yup.string().required(),
  })
  .required();
